import { Button } from '@remente/shared-frontend';
import { useErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';


// Throw an error to see the error boundary in action
// throw new Error('Something went wrong');
/** ex.   const handleLogin = async (e: FormEvent) => {
    try {
      await login(username, password);
    } catch (error) {
      setErrorState({ error: error as Error, message: t('login_page.login_error') });
    }
  };
  if (errorState) {
    throw errorState.error;
  } */

export const ErrorFallback = () => {
  const { resetBoundary } = useErrorBoundary();
  const { t } = useTranslation();

  return (
    <div role="alert">
      <p>{t('error_boundary.error')}</p>

      <Button onClick={resetBoundary}>{t('error_boundary.try_again')}</Button>
    </div>
  );
};
